// Update your Banner component
import React from 'react'
import { Text, useMainContext } from '../../../modules/Dashboard'
import { Link } from 'react-router-dom'
import SparklesSolidIcon from '../../../components/icons/SparklesSolidIcon'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'

const Banner = () => {
    const { main: { lang } } = useMainContext()

    return (
        <div className='w-full rounded-2xl bg-gradient-to-r from-[#009966] to-[#009689] p-6 
            transition-all duration-500 ease-out hover:transform hover:-translate-y-1 
            hover:shadow-2xl hover:shadow-[#009966]/30 group'>

            <div className='flex flex-col md:flex-row justify-between items-center gap-4'>
                <ul className='space-y-2 max-w-3xl'>
                    <li className='flex items-center gap-1 group-hover:translate-x-1 transition-transform duration-300'>
                        <SparklesSolidIcon color='#FFDF20' className='group-hover:rotate-12 transition-transform duration-500' />
                        <Text tid="limited-time-offer" className='uppercase text-[#FFDF20]' />
                    </li>
                    <li>
                        <Text tid="offer-title" className='text-2xl lg:text-4xl font-semibold 
                            transition-all duration-300 group-hover:tracking-wide' />
                    </li>
                    <li>
                        <Text tid="offer-desc" className='lg:text-lg opacity-90 
                            group-hover:opacity-100 transition-opacity duration-300' />
                    </li>
                </ul>
                <Link className='px-4 py-2 rounded-lg flex justify-center items-center gap-1 
                    text-[#9810FA] bg-[#fcf7f7] w-full md:w-max transition-all duration-300 
                    hover:scale-105 hover:shadow-lg hover:shadow-white/20 active:scale-95
                    group-hover:bg-white'>
                    <Text tid={"learn-more"} className='text-inherit' />
                    {
                        lang === 'fa' ?
                            <BsArrowLeft className='group-hover:translate-x-[-2px] transition-transform' /> :
                            <BsArrowRight className='group-hover:translate-x-[2px] transition-transform' />
                    }
                </Link>
            </div>

            {/* Optional: Add a subtle shine effect */}
            <div className="absolute inset-0 rounded-2xl overflow-hidden opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/5 to-transparent 
                    translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />
            </div>
        </div>
    )
}

export default Banner